'use strict';

import React, { useState } from 'react';
import PageFrame, { PHONE } from './PageFrame';
import BecomeApplicantV2Process from './becomeApplicantV2Process';
import { parseLoanParams } from './applicationContext';

/**
 * New yrityslaina application flow (/hae-yrityslainaa).
 *
 * One centered column; the URL only decides how the loan card starts:
 *  - no loan parameters   → sliders open inside the card
 *  - loanamount & length  → collapsed summary with a "Muokkaa" link
 *
 * Fully separate from becomeApplicant/ — the live flow is not touched.
 */

// Same guidance the live form shows under the application.
const afterForm = (
  <>
    <p>Oletko hakemassa yritykselle luottolimiittiä? Voit siirtyä limiittiluoton avaamiseen <a href="/avaa-luottolimiitti">tästä</a>.</p>
    <p>Jos olet jo asiakkaamme, voit kirjautua sivuillesi <a href="https://app.kasvurahoitus.fi/login">tästä</a>. Asiakaspalvelumme on tavoitettavissa puhelimitse numerossa <a href={PHONE.href}>{PHONE.intl}</a> (ark. klo 9-16) ja sähköpostitse osoitteessa <a href="mailto:asiakaspalvelu@kasvurahoitus.fi">asiakaspalvelu@kasvurahoitus.fi</a>.</p>
  </>
);

export default function BecomeApplicantV2({ match, history }) {
  const context = parseLoanParams(match, history && history.location ? history.location.search : '');
  const [step, setStep] = useState(1);
  return (
    <PageFrame
      promo={<>Nyt uusiin yrityslainoihin <strong>1–3 kuukauden lyhennysvapaa</strong> maksuohjelman alkuun veloituksetta.</>}
      contactEmail="yrityslaina@kasvurahoitus.fi"
      afterForm={step === 1 ? afterForm : null}
    >
      <BecomeApplicantV2Process context={context} onStepChange={setStep} />
    </PageFrame>
  );
}
